import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/Done';
import clsx from 'clsx';
import { IRequestCalloutDTO } from '../calloutRequested/types/IRequestCalloutDTOs';
import { Button } from '@material-ui/core';
import CalloutStatuses from '../types/CalloutStatuses';
import {getLabelNameForDirver} from './calloutResponseHelpers'; 

interface CalloutStatusLabelForManagerProps {
    row: IRequestCalloutDTO
};

const useStyles = makeStyles({
    container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: 'center'
    },
    iconBox: {
        width: 30,
        height: 30,
        borderRadius: 26,
        zIndex: 2,
        backgroundColor: '#3FA052',
    },
    icon: {
        color: "white", 
        fontSize:'1.4rem',
        paddingTop:'3px',
        paddingLeft:'3px',       
    },
    labelText:{
        fontSize: 16, 
        fontWeight: 500,
        fontFamily: 'lato',
        borderRadius: 4, 
        marginLeft: 8, 
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: 140,
        display: "flex",
    },
});


const CalloutStatusLabelForManager: React.FC<CalloutStatusLabelForManagerProps> = ({
    row}) => {
    const classes = useStyles();
    if(row.status === CalloutStatuses.dispatchedToTeam){
        return null;
    }
    return (
        <div className={classes.container}>
            <span className={classes.iconBox}>
                <DoneIcon className={classes.icon} />
            </span>
            <span className={classes.labelText}>Assigned to {row.assignedVehicle}</span>
        </div>
    );
}

export default CalloutStatusLabelForManager;
